import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class WidgetCoordinatorService {
  private cancelAllSubject = new Subject<string>();
  cancelAll$ = this.cancelAllSubject.asObservable();

  requestCancelAll(exceptId: string) {
    this.cancelAllSubject.next(exceptId);
  }
}
